import type { Workflow } from '@couch/shared';

const isLink = (v: unknown): v is [string, number] => Array.isArray(v) && v.length === 2 && typeof v[0] === 'string' && typeof v[1] === 'number';

function Value({ value }: { value: unknown }) {
  if (isLink(value)) return <span className="muted">← node {value[0]}</span>;
  if (typeof value === 'string') return <span className="wf-text">{value === '' ? '“”' : value}</span>;
  return <span>{JSON.stringify(value)}</span>;
}

/** One row per node: id, type and its inputs, links shown as "← node 4". Sorted by numeric id. */
export function WorkflowSummary({ workflow }: { workflow: Workflow }) {
  const ids = Object.keys(workflow).sort((a, b) => (Number(a) - Number(b)) || a.localeCompare(b));
  return (
    <div className="table-scroll">
      <table className="workflow-table">
        <thead><tr><th>Node</th><th>Type</th><th>Inputs</th></tr></thead>
        <tbody>
          {ids.map((id) => {
            const node = workflow[id];
            if (!node) return null;
            return (
              <tr key={id}>
                <td>{id}</td>
                <td>{node._meta?.title && node._meta.title !== node.class_type ? <>{node._meta.title} <span className="muted">({node.class_type})</span></> : node.class_type}</td>
                <td>
                  <dl className="wf-inputs">
                    {Object.entries(node.inputs).map(([name, value]) => (
                      <div key={name}><dt>{name}</dt><dd><Value value={value} /></dd></div>
                    ))}
                  </dl>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
